import { Card, Grid } from "@mui/material";
import CameraLocationCard from "./CameraLocationCard.js"

import PropTypes from "prop-types";
import LatestCameraImageWithLine from "../LatestCameraImageWithLine/index.js";
import SoftTypography from "components/SoftTypography/index.js";
import SoftBox from "components/SoftBox/index.js";
import SoftButton from "components/SoftButton/index.js";
import { useState } from "react";

const available_devices = [{
    uuid: "c2a0da1ed5b0c6c1",
    name: "Device 1"
},
{
    uuid: "9ee9a4482f019470",
    name: "Device 2"
},
{
    uuid: "9c1a4014e3819bc3",
    name: "Device 3"
}
]

function createEventCameraLocation(device) {
    return {
        "uuid": device.uuid,
        "name": device.name,
        "line_counter_coordinates": {
            "x1": 235,
            "y1": 480,
            "x2": 906,
            "y2": 480
        }
    }
}





function CameraLocationsGridView({ locations, setLocations }) {

    console.log(locations)

    function toggleDevice(location) {
        let locationsUuids = locations.map(r => r.uuid);
        let locationsIndex = locationsUuids.indexOf(location.uuid);

        // debugger;
        if (location.enabled) {
            setLocations(locations.filter((row, index) => index != locationsIndex))
        }
        else {
            setLocations([...locations, createEventCameraLocation(location)])
        }
    }

    let locationsUuids = locations.map(r => r.uuid);

    let mixedLocations = [...available_devices].map((row) => {

        let locationsUuids = locations.map(r => r.uuid);
        let locationsIndex = locationsUuids.indexOf(row.uuid);

        if (locationsIndex >= 0) {
            let ret = locations[locationsIndex];
            if (!ret.line_counter_coordinates && locationsIndex >= 0) {
                ret.line_counter_coordinates = locations[locationsIndex].line_counter_coordinates;
            }
            ret.enabled = true;
            return ret
        }


        row = { ...createEventCameraLocation(row) }
        row.enabled = false;
        row.line_counter_coordinates = null;

        return row;

    });



    return (
        <Grid container spacing={3}>
            {mixedLocations.map(function (location, index) {
                return (
                    <Grid item xs={4} key={index}>
                        <Card sx={{ border: location.enabled ? "lightblue solid 2px" : "white solid 2px" }}>
                            <SoftBox m={2}>
                                <SoftBox mb={2} display="flex" alignItems="center">
                                    <SoftTypography sx={{ flexGrow: 1 }}>
                                        {location.name}
                                    </SoftTypography>

                                    <SoftButton sx={{ border: location.enabled ? "lightblue solid 2px" : "white solid 2px" }}
                                        onClick={() => { toggleDevice(location, index) }}
                                    >
                                        {location.enabled ? "Enabled" : "Disabled"}
                                    </SoftButton>
                                </SoftBox>
                                <LatestCameraImageWithLine uuid={location.uuid} coordinates={{ ...location.line_counter_coordinates }} setCoordinates={(coordinates) => {
                                    setLocations(function (current_value) {

                                        let locationsUuids = locations.map(r => r.uuid);
                                        let locationsIndex = locationsUuids.indexOf(location.uuid)

                                        coordinates = {
                                            x1: Math.round(coordinates.x1),
                                            y1: Math.round(coordinates.y1),
                                            x2: Math.round(coordinates.x2),
                                            y2: Math.round(coordinates.y2)
                                        }

                                        if (current_value[locationsIndex].line_counter_coordinates) {
                                            current_value[locationsIndex].line_counter_coordinates = coordinates
                                        }


                                        return [...current_value]
                                    })
                                }} />
                            </SoftBox>
                        </Card>
                    </Grid>
                )
            })}

        </Grid>
    )



}



export default CameraLocationsGridView;